import styled from 'styled-components';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

export const StyledSubheaderTypography = styled(Typography)<TypographyProps>`
  && {
    margin-left: ${({ theme }) => theme.spacing(1.5)}px;
  }
`;
